export type Alignment = 'center' | 'left' | 'right';
